import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventSubItem from './EventSubItem';
import { filter } from 'lodash';
import { l10n } from '../../common/constants';
import {
  getFormDefinition,
  getPluginKey,
  getSeragamGender,
  getSessionContext,
  PLUGIN_MISSION_TRIP,
  PLUGIN_SERAGAM,
} from '../form-builder/schemaRuntime';

const seragamExclusives = Array.from(
  { length: 20 },
  (_, index) => `seragam${index + 1}`
);
const MISSION_TRIP_EXCLUSIVE = "missiontrip";
const defaultSeragamGroup = 'Pilihan Ukuran';
const seragamGroupOrder = ['Pria', 'Wanita', 'Anak', defaultSeragamGroup];
const seragamGroupLabels = {
  Pria: 'seragamGroupMan',
  Wanita: 'seragamGroupWoman',
  Anak: 'seragamGroupKids',
  [defaultSeragamGroup]: 'seragamGroupDefault',
};

const getSeragamGroup = (name = '') => {
  const groupMatch = name.match(/\[(.*?)\]/);
  if (groupMatch && groupMatch[1]) {
    return groupMatch[1].trim();
  }

  const normalizedName = name.toLowerCase();
  if (normalizedName.includes('pria')) {
    return 'Pria';
  }

  if (normalizedName.includes('wanita')) {
    return 'Wanita';
  }

  if (normalizedName.includes('anak')) {
    return 'Anak';
  }

  return defaultSeragamGroup;
};

const isMissionTripMealbox = (name = '') => /meal\s*box|nasi\s*kotak/i.test(name);

class EventSubList extends Component {
  state = {
    selectedGroup: null,
  };

  onChangeSeragamFilter = (selectedGroup) => {
    this.setState((prevState) => ({
      selectedGroup: prevState.selectedGroup === selectedGroup ? null : selectedGroup,
    }));
  };

  render() {
    if (this.props.event.sub_event) {
      let sub_events_date = filter(this.props.event.sub_event, { service_date: this.props.event.uniqueDates[this.props.selectedDate].date });
      let sub_events = [];
      sub_events_date.forEach((part) => {
        if (sub_events.map(e => { return e.name }).indexOf(part.name) === -1) {
          sub_events.push(part);
        }
      });

      const ignoredIds = [15111, 15110, 15109]; //# Christmas Celebration 2025 Surabaya Rooftop Overflow
      const filteredSubEvents = sub_events.filter((eventSub) => !ignoredIds.includes(eventSub.id));
      const definition = getFormDefinition(this.props.event);
      const pluginKey = getPluginKey(this.props.event);
      const isSeragamEvent =
        seragamExclusives.includes(this.props.event.exclusive) ||
        pluginKey === PLUGIN_SERAGAM;
      const isMissionTripEvent =
        this.props.event.exclusive === MISSION_TRIP_EXCLUSIVE ||
        pluginKey === PLUGIN_MISSION_TRIP;

      if (isMissionTripEvent) {
        const isMealbox = (eventSub) => definition
          ? getSessionContext(definition, eventSub, this.props.language).package_type === 'mealbox'
          : isMissionTripMealbox(eventSub.name);
        const accommodationSubEvents = filteredSubEvents.filter((eventSub) => !isMealbox(eventSub));
        const mealboxSubEvents = filteredSubEvents.filter((eventSub) => isMealbox(eventSub));
        const missionTripGroups = [
          {
            key: 'akomodasi',
            title: 'Paket Akomodasi',
            items: accommodationSubEvents,
          },
          {
            key: 'nasi-kotak',
            title: 'Paket Nasi Kotak',
            items: mealboxSubEvents,
          },
        ].filter((group) => group.items.length > 0);

        return (
          <div className="mission-trip-package-list">
            <div className="mission-trip-package-intro">
              <div>Tersedia Paket Akomodasi dan Paket Nasi Kotak</div>
              <div className="mission-trip-package-intro__note">
                <ul>
                  <li>Anda hanya dapat memilih satu paket dari pilihan yang tersedia dan Anda hanya dapat melakukan 1x transaksi pembelian.</li>
                  <li>Paket Hotel & Transport sudah termasuk nasi kotak selama event berlangsung.</li>
                  <li>Apabila Anda tidak membutuhkan akomodasi (Hotel & Transport), Anda bisa memilih Paket Nasi Kotak.</li>
                </ul>
              </div>
            </div>
            <div className="mission-trip-package-columns">
              {missionTripGroups.map((group) => (
                <div key={group.key} className="mission-trip-package-section">
                  <div className="mission-trip-package-section__header">
                    <div className="mission-trip-package-section__title">
                      {group.title}
                    </div>
                    <div className="mission-trip-package-section__count">
                      {group.items.length} pilihan
                    </div>
                  </div>
                  <div className="mission-trip-package-section__cards">
                    {group.items.map((eventSub) => (
                      <EventSubItem
                        key={eventSub.id}
                        eventSub={eventSub}
                        event={this.props.event}
                        language={this.props.language}
                        selectEvent={this.props.selectEvent}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      }

      if (!isSeragamEvent) {
        return filteredSubEvents.map((eventSub) => (
          <EventSubItem key={eventSub.id} eventSub={eventSub} event={this.props.event} language={this.props.language} selectEvent={this.props.selectEvent} />
        ));
      }

      const groupedSubEvents = filteredSubEvents.reduce((groups, eventSub) => {
        const groupName = definition
          ? getSeragamGender(eventSub)
          : getSeragamGroup(eventSub.name);
        if (!groups[groupName]) {
          groups[groupName] = [];
        }

        groups[groupName].push(eventSub);
        return groups;
      }, {});

      const orderedGroupNames = Object.keys(groupedSubEvents).sort((groupA, groupB) => {
        const groupAIndex = seragamGroupOrder.indexOf(groupA);
        const groupBIndex = seragamGroupOrder.indexOf(groupB);
        const normalizedIndexA = groupAIndex === -1 ? seragamGroupOrder.length : groupAIndex;
        const normalizedIndexB = groupBIndex === -1 ? seragamGroupOrder.length : groupBIndex;

        if (normalizedIndexA === normalizedIndexB) {
          return groupA.localeCompare(groupB);
        }

        return normalizedIndexA - normalizedIndexB;
      });

      const filterOptions = orderedGroupNames.map((groupName) => ({
        label: l10n[seragamGroupLabels[groupName] || "seragamGroupDefault"][this.props.language || "ind"],
        value: groupName,
        count: groupedSubEvents[groupName].length,
      }));

      const activeGroup = filterOptions.some((option) => option.value === this.state.selectedGroup)
        ? this.state.selectedGroup
        : null;

      const visibleGroupNames = activeGroup
        ? orderedGroupNames.filter((groupName) => groupName === activeGroup)
        : orderedGroupNames;

      return (
        <div className="event-sub-list--seragam">
          {filterOptions.length > 1 && (
            <div className="event-sub-list__filter-bar">
              <div className="event-sub-list__filter-actions">
                {filterOptions.map((option) => (
                  <button
                    key={option.value}
                    type="button"
                    className={`event-sub-list__filter-chip ${activeGroup === option.value ? 'event-sub-list__filter-chip--active' : ''}`}
                    onClick={() => this.onChangeSeragamFilter(option.value)}
                  >
                    {option.label}
                    <span className="event-sub-list__filter-chip-count">{option.count}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
          {visibleGroupNames.map((groupName) => (
            <div key={groupName} className="event-sub-list__group">
              <div className="event-sub-list__group-header">
                <div className="event-sub-list__group-title">{l10n[seragamGroupLabels[groupName] || "seragamGroupDefault"][this.props.language || "ind"]}</div>
                <div className="event-sub-list__group-count">
                  {groupedSubEvents[groupName].length} {l10n.sizes[this.props.language || "ind"]}
                </div>
              </div>
              <div className="event-sub-list__grid">
                {groupedSubEvents[groupName].map((eventSub) => (
                  <EventSubItem key={eventSub.id} eventSub={eventSub} event={this.props.event} language={this.props.language} selectEvent={this.props.selectEvent} />
                ))}
              </div>
            </div>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }
}

// PropTypes
EventSubList.propTypes = {
  event: PropTypes.object.isRequired,
  language: PropTypes.string,
  selectEvent: PropTypes.func.isRequired,
}

export default EventSubList;
